import Vue from "vue";
import Vuetify from "vuetify/lib";
import { vuetifyLocales } from "@/i18n";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg"
  },
  lang: {
    locales: vuetifyLocales,
    current: "en"
  }
});
